<script setup lang="ts">
defineProps()

const isFirstTime = ref(true)

const { isPending, start, stop } = useTimeoutFn(() => {
  if (isFirstTime.value) {
    // Do not trigger sendEvent for the first time
    isFirstTime.value = false
    return
  }
}, 1500)

const onClickedFilter = (filter: { min: number; max: number }) => {
  if (isPending) stop()

  start()
}
</script>

<template>
  <FiltersUtilsGroup
    name="price"
    id-facet="price.amount_float"
    content-class="pb-5"
    facet-name="price.amount_float"
    :title="$t('filters.utils.common.price')"
  >
    <AisRangeInput attribute="price.amount_float">
      <template v-slot="{ currentRefinement, range, refine }">
        <FkSlider
          :model-value="{
            min:
              typeof currentRefinement.min === 'number'
                ? currentRefinement.min
                : range.min,
            max:
              typeof currentRefinement.max === 'number'
                ? currentRefinement.max
                : range.max
          }"
          name="range"
          :label="$t('filters.utils.common.price')"
          :min="range.min"
          :max="range.max"
          :step="1"
          :gap="1"
          currency="€"
          @update:model-value="
            ($event) => {
              onClickedFilter({
                min: $event.min,
                max: $event.max
              })
              refine({ min: $event.min, max: $event.max })
            }
          "
        />
      </template>
    </AisRangeInput>
    <div class="pt-2">
      <AisToggleRefinement
        attribute="isDiscounted"
        :label="$t('filters.utils.price.isDiscounted')"
      >
        <template v-slot="{ canRefine, refine, value }">
          <FiltersUtilsOption
            name="is-discounted"
            :checked="value.isRefined"
            :disabled="!canRefine"
            @clicked="refine(value)"
            :text="$t('filters.utils.price.isDiscounted')"
            :n-results="canRefine ? value.count : 0"
            type="toggle"
          />
        </template>
      </AisToggleRefinement>
    </div>
  </FiltersUtilsGroup>
</template>
